import React from "react"
import Layout from "../../shared/components/organisms/layout/layout"
import SEO from "../../shared/seo"
import SubcategoryContent from "../organisms/subcategory-content/subcategory-content"

const SubcategoryTemplate = props => {
  const { pageContext } = props

  const [isMobile, setMobileBool] = React.useState(false)
  const [modalActive, setModalActive] = React.useState()

  const updateDimensions = () => {
    setMobileBool(window.innerWidth < 1024 ? true : false)
  }

  React.useEffect(() => {
    updateDimensions()
    window.addEventListener("resize", updateDimensions)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [])

  return (
    <Layout mobile={isMobile} modalActive={modalActive} title={props.pageContext.params.titulo} >
      <SEO 
        title={props.pageContext.params.titulo} 
        url={`/productos/${pageContext.paternSlug}/${pageContext.params.slug}`}
      />
      <SubcategoryContent
        setModalActive={setModalActive}
        mobile={isMobile}
        context={pageContext}
      />
    </Layout>
  )
}

export default SubcategoryTemplate
